import styled, { css } from "styled-components";

import { transition, text } from "@ui/helpers";
import * as Grid from "@ui/Atoms/Grid";
import { Text } from "@ui/Atoms/Text";

interface CommonProps {
  selected: boolean;
}

export const Root = styled(Grid.Container).attrs({ as: "section" })`
  padding-top: ${({ theme }) => theme.spacing.spacing_48};
  padding-bottom: ${({ theme }) => theme.spacing.spacing_48};

  ${props => props.theme.breakpoints.tablet} {
    padding-top: ${({ theme }) => theme.spacing.spacing_64};
    padding-bottom: ${({ theme }) => theme.spacing.spacing_64};
  }
  ${props => props.theme.breakpoints.desktop} {
    padding-top: ${({ theme }) => theme.spacing.spacing_80};
    padding-bottom: ${({ theme }) => theme.spacing.spacing_80};
  }
`;

export const Container = styled.div`
  --start-booking-max-width: 588px;

  padding: ${({ theme }) => theme.spacing.spacing_32} 0;
  border-radius: ${({ theme }) => theme.border.radius.base};
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.spacing_24};

  ${props => props.theme.breakpoints.tablet} {
    margin: 0 -${({ theme }) => theme.spacing.spacing_16};
  }
`;

export const Title = styled(Text)`
  max-width: var(--start-booking-max-width);
  padding: 0 ${({ theme }) => theme.spacing.spacing_16};
  text-align: center;
`;

export const Body = styled.div`
  max-width: var(--start-booking-max-width);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.spacing_24};

  ${props => props.theme.breakpoints.tablet} {
    gap: ${({ theme }) => theme.spacing.spacing_48};
  }
`;

export const CleaningSelector = styled.ul`
  width: 100%;
  margin: 0;
  padding: 0 ${({ theme }) => theme.spacing.spacing_4};
  list-style: none;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: ${({ theme }) => theme.spacing.spacing_8};

  ${props => props.theme.breakpoints.tablet} {
    max-width: 528px;
    padding: 0 ${({ theme }) => theme.spacing.spacing_16};
  }
`;

export const CleaningSelectorItem = styled.li`
  padding: ${({ theme }) =>
    `${theme.spacing.spacing_16} ${theme.spacing.spacing_12} 0`};
  flex: 0 1 33.3333%;
  display: flex;
  align-items: stretch;
`;

export const CleaningTypeIcon = styled.span`
  flex-shrink: 0;
`;

export const CleaningTypeButton = styled.button.attrs({
  type: "button",
})<CommonProps>`
  all: unset;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.spacing_8};
  cursor: pointer;
  user-select: none;

  ${props =>
    props.selected &&
    css`
      pointer-events: none;
    `}

  &:hover {
    &::after {
      ${props => props.theme.breakpoints.tablet} {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }

  &::after {
    content: "";
    flex: 0 0 4px;
    width: 100%;
    height: 4px;
    background-color: currentColor;
    transition: ${transition(["transform", "opacity"])};
    transform: translateY(calc(100% + 1px));
    opacity: 0;

    ${props =>
      props.selected &&
      css`
        transform: translateY(0);
        opacity: 1;
      `}
  }
`;

export const CleaningTypeButtonLabel = styled(Text).attrs({
  as: "span",
  $style: "regular_16",
})<CommonProps>`
  flex: 1 1 100%;
  transition: ${transition("font-weight", "100ms")};

  ${props =>
    props.selected &&
    css`
      ${text("bold_16")}
    `}
`;

export const FormWrapper = styled.div`
  width: 100%;
  padding: 0 ${({ theme }) => theme.spacing.spacing_12};

  ${props => props.theme.breakpoints.tablet} {
    width: calc(100% - (2 * ${({ theme }) => theme.spacing.spacing_64}));
    padding: 0;
  }
`;
